LoginController.$inject = ['$location', '$window', 'AuthenticationService'];

export default function LoginController($location, $window, AuthenticationService) {
    var ctrl = this;

    ctrl.reset = reset;

    ctrl.$onInit = function() {
        ctrl.isAuthenticated = AuthenticationService.isAuthenticated();
        reset();
    };

    ctrl.loginAsPatron = function() {
        var self = this;
        AuthenticationService.login(ctrl.identifier, ctrl.password, function(result) {
            if (result === true) {
                $location.path('/');
            } else {
                self.error = __("username or password is incorrect");
            }
        });
    }

    ctrl.loginAsPortalUser = function() {
        $window.location.href='/api/v1/auth/portal';
    }

    ctrl.loginAsYandexUser = function() {
        $window.location.href='/api/v1/auth/yandex';
    }

    ctrl.logout = function() {
        var self = this;
        AuthenticationService.logout(function(result) {
            if (result === true) {
                $location.path('/');
            } else {
                self.error = __("logout failed");
            }
        });
    }

    /*
    ctrl.logoutAsPortalUser = function() {
        $window.location.href='/api/v1/auth/portal/logout';
    }
    ctrl.logoutAsYandexUser = function() {
        console.log('logout as yandex user');
        $window.location.href='/api/v1/auth/logout';
    }
    */

    ////////
    
    function reset() {
        ctrl.identifier = null;
        ctrl.password = null;
        ctrl.error = null
    }

}
